// extracted by mini-css-extract-plugin
export default {"root":"_1BfKI5WI","content":"_3VjnFAkq","iframe":"_3O5Fu-8V","headerBtns":"_2C5uq6yL","headerLink":"_12-UKYGS"};